import React from 'react';
import {connect} from 'react-redux';

import {fetchWebhooks, selectWebhooks} from 'ducks/webhooks';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import PageWithoutSideMenu from 'components/PageWithoutSideMenu';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import VisibleIf from 'components/VisibleIf';
import {WebhooksTable, SchedulerRunsChart} from './components';

import './styles.css';

class Webhooks extends React.Component<
  LoginRequiredProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  componentDidMount() {
    this.props.requiresPermission(
      {
        permission: PERMISSIONS.VIEW_WEBHOOKS
      },
      this.props.fetchWebhooks
    );
  }

  render() {
    const {webhooks} = this.props;

    return (
      <PageWithoutSideMenu>
        <div className="Webhooks">
          <VisibleIf permission={PERMISSIONS.VIEW_WEBHOOKS}>
            <WebhooksTable webhooks={webhooks} />
            <SchedulerRunsChart />
          </VisibleIf>
        </div>
      </PageWithoutSideMenu>
    );
  }
}

const mapStateToProps = state => ({
  webhooks: selectWebhooks(state)
});

const mapDispatchToProps = {requiresPermission, fetchWebhooks};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(Webhooks)
);
